'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");


/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BSSTags(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bsstags', 
        //extends: 'bssselect',
        template: require("./bsstags.html"),
        controller: ["$scope", "$filter", "$timeout", "$http", "ErrorManager", "DSFactory", require("./BssTagsController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bsstags'
            },
        }
    }));
}

module.exports = BSSTags;